'use strict';

module.exports = function (marty) {
  marty.Queries = require('./queries');
  marty.createQueries = require('./createQueriesClass');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/queries/index.js
// module id = brkO
// module chunks = 88